import { getDeepProperty as getDeepObjectProperty } from "@/utils/object";
import * as AssetAPI from "@/services/api/assets";

type Dictionary<T> = { [k:string]:T }

type RefInfo = {
	missing?:boolean;
	valid?:boolean;
}

type LabelFactory = (node:any, parameters:any) => Promise<RefInfo>

const factories:Dictionary<LabelFactory> = {};

factories["CognitiveTest"] = async (node, parameters) => {
	// if(node.name){ return node.name; }
	const useAsset = getDeepObjectProperty(parameters, "useAsset", false);
	const assetId = getDeepObjectProperty(parameters, "asset.ref.asset", null);
	if(useAsset && assetId){
		try {
			const asset = await AssetAPI.getAsset(assetId);
			return { valid:true };
		}
		catch(err){}
		return { missing:true, }
	}
	return {
		valid:false,
	}
}

factories["Form"] = async (node, parameters) => {
	// if(node.name){ return node.name; }
	const assetId = getDeepObjectProperty(parameters, "asset.ref.asset", null);
	if(!assetId){ return { } }
	try {
		const asset = await AssetAPI.getAsset(assetId);
		return { valid:true };
	}
	catch{}
	return { missing:true, }
}

factories["Select"] = async (parameters) => {
	return { valid:true, };
}

factories["Scene"] = async (node, parameters) => {
	return { valid:true }
}

factories["Gallery"] = async (node, parameters) => {
	// if(node.name){ return node.name; }
	const assetId = getDeepObjectProperty(parameters, "asset.ref.asset", null);

	if(!assetId){ return {}; }

	try {
		const asset = await AssetAPI.getAsset(assetId);
		return { valid:true }
	}
	catch{}
	return { missing:true, }
}

export const checkNodeRefs = async (node:any) => {
	const factory = factories[node.type];
	if(!factory){ return {}; }
	return await factory(node, node.parameters);
}